import { useState, useEffect } from 'react'

/**
 * Increments a free persistent counter on counterapi.dev every time the site
 * is loaded and displays the total visit count in the footer.
 *
 * API docs: https://counterapi.dev
 * Namespace: newgensolar-in  |  Key: visits
 */
export const VisitorCounter = () => {
  const [count, setCount] = useState(null)

  useEffect(() => {
    fetch('https://api.counterapi.dev/v1/newgensolar-in/visits/up')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.count !== undefined) setCount(data.count)
      })
      .catch(() => {
        // Silently fail — counter is non-critical
      })
  }, [])

  if (count === null) return null

  return (
    <span className='visitor-counter'>
      <i className='fa fa-eye'></i>&nbsp;
      {count.toLocaleString('en-IN')} visits
    </span>
  )
}

